export const otherModule = {
  loadingPay: "正在获取支付结果",
  goDetail: "跳转订单详情"
};
